import useUserStore from 'store/useUserStore'
import classNames from 'classnames'
import { Input } from 'components/atom/Input'
import { TextArea } from 'components/atom/TextArea'
import useConfirmPoint from 'hooks/query/point/useConfirmPoint'
import { useShortVideoData } from 'hooks/useShortVideoData'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import { Controller, useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { getShortImageList, ShortVideoInfo } from 'service/list'
import { getLocalStorage, saveLocalStorage } from 'utils/common'
import { contentVideoFormValues } from 'utils/type'

import { ShadowBox } from 'components/ShadowBox'
import { CSSTransition } from 'react-transition-group'
import ContentTooltip from '../shortvideo/ContentToolitip'
import { ShortBgmDisplay } from 'pages/content-video-editor/components/shortvideo/ShortBgmDisplay'
import { SubtitleDisplay } from '../shortvideo/SubtitleDisplay'
import { AiScriptDisplay } from '../shortvideo/AiScriptDisplay'
import { Modal } from 'components/layout/Modal'
import CashUseModal from 'components/CashUseModal'
import { Spinner } from 'components/atom/Spinner'
import ConfirmPaymentCashModal from 'components/payment/ConfirmPaymentCashModal'

import { FeatureDescription } from 'components/FeatureDescription'
import { VideoRatioType } from '../shortvideo/VideoRatioType'
import { ContentLayoutSelector } from 'pages/content-video-editor/components/contentLayoutSelector'
import { ImageUploadBox } from '../ImageUploadBox'
import { initializeDefaults } from 'pages/content-video-editor/utils'

interface LinkTypeProps {
  tab: 'link' | 'text'
  setTab: Dispatch<SetStateAction<'link' | 'text'>>
  changeTab: (string: 'link' | 'text') => void
}
export const LinkType = ({
  tab,
  setTab,
  changeTab,
}: PropsWithChildren<LinkTypeProps>) => {
  const [promptStatus, setPromptStatus] = useState<boolean[]>([])

  const urlParams = new URLSearchParams(window.location.search)
  const amount = urlParams.get('amount')
  const bonus = urlParams.get('bonus')
  const pType = urlParams.get('pType')
  const mType = urlParams.get('mType')
  const memory = urlParams.get('m')
  const promotionCode = urlParams.get('promotionCode')
  const valid = urlParams.get('valid')

  const PRODUCT_NAME_PATTERN = /^[^<>\uD800-\uDFFF]*$/

  const shortVideoData = getLocalStorage('shortVideoData')

  // 여러개의 요소들의 api를 한곳에 모아서 보고있음
  const {
    myPointData,
    getMyPointRefetch,
    bgmList,
    subTitleList,
    voiceList,
    toneList,
    animationList,
    aiPromptDurationList,
    bgList,
    templateList,
    voiceTags,
    subtitleColorList,
    tempoList,
    userVoiceList,
    userVoiceRefetch,
  } = useShortVideoData()

  const { mutate: confirmPointMutate, isPending } = useConfirmPoint()
  const navigate = useNavigate()
  const userInfo = useUserStore((state: any) => state.userInfo)

  const userCheck = () => {
    if (!userInfo) {
      navigate('/sign-up')
      return
    }
  }
  const location = useLocation()
  const { pathname } = useLocation()
  const [isCrawlingLoading, setCrawlingLoading] = useState<boolean>(false)
  const [isSuccess, setSuccess] = useState<boolean>(false)
  const [isRequest, setRequest] = useState<boolean>(true)
  const [saveSuccessModal, setSaveSuccessModal] = useState<boolean>(false)
  const [essentialCheck, setEssentialCheck] = useState<boolean>(false)
  const [isUseModal, setUseModal] = useState<boolean>(false)
  const [isModal, setModal] = useState<boolean>(false)
  const [hasLinkError, setHasLinkError] = useState<boolean>(false)

  const [amountValue, setAmountValue] = useState(0)
  const [bonusValue, setBonusValue] = useState(0)
  const [errorText, setErrorText] = useState<string>('')
  const [errorCode, setErrorCode] = useState<number>(0)

  const [shortVideoInfo, setShortVideoInfo] = useState<ShortVideoInfo>({
    mainTitle: '',
    templateTitle: '',
    link: '',
    backgroundId: 0,
    aiToneTypeId: 0,
    bgmId: 0,
    voiceId: 0,
    userVoiceId: 0,
    templateId: 0,
    templateType: '',
    subtitleId: 0,
    aiPromptDurationId: 0,
    amount: 0,
    subtitleColorId: 0,
    tempoId: 0,
    urls: [],
  })

  const [shortVideoPriceInfo, setShortVideoPriceInfo] = useState({
    bgmPrice: 0,
    voicePrice: 0,
    templatePrice: 0,
    subtitlePrice: 0,
  })

  //tooltip 관련 useState
  const [contentTooltipStatus, setContentTooltipStatus] =
    useState<boolean>(false)
  const [bgmTooltip, setBgmTooltip] = useState<boolean>(false)
  const [subtitleTooltip, setSubtitleTooltip] = useState<boolean>(false)
  const [selectedImagePath, setSelectedImagePath] = useState<string>('')
  const [images, setImages] = useState<string[]>([])
  const [splitTitles, setSpiltTitles] = useState<string[]>([])
  const [uploadImages, setUploadImages] = useState<
    {
      id: number
      file: File
      preview: string
      uploading: boolean
    }[]
  >([])
  const [selectedImages, setSelectedImages] = useState(
    new Array(images.length).fill(true)
  )
  const [selectedUploadImages, setSelectedUploadImages] = useState(
    new Array(uploadImages.length).fill(true)
  )

  const [selectedOrder, setSelectedOrder] = useState<number[]>([])

  // inputRef
  const mainTitleInputRef = useRef<null | HTMLInputElement>(null)
  const isDisabled = selectedOrder.length === 0 && uploadImages.length === 0
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<contentVideoFormValues>({
    defaultValues: {
      link: '',
      mainTitle: '',
      templateTitle: '',
      voiceId: 0,
      userVoiceId: 0,
      bgmId: 0,
      backgroundId: 0,
      templateType: '',
      templateId: 0,
      aiToneTypeId: 0,
      subtitleId: 0,
      aiPromptDurationId: 0,
      subtitleColorId: 0,
      withShort: 0,
    },
  })

  const linkValue = watch('link')

  useEffect(() => {
    if (linkValue === '') {
      setImages([]) // link 값이 빈 문자열이 될 때 이미지를 초기화
      setSelectedImages([]) // link 값이 빈 문자열이 될 때 이미지를 초기화
      setUploadImages([])
      setSelectedUploadImages([]) // link 값이 빈 문자열이 될 때 이미지를 초기화
      setSpiltTitles([])
    }
  }, [linkValue])

  const onSubmit = async (data: any) => {
    userCheck()
    let {
      mainTitle,
      templateTitle,
      link,
      voiceId,
      userVoiceId,
      bgmId,
      aiToneTypeId,
      backgroundId,
      templateId,
      subtitleId,
      templateType,
      aiPromptDurationId,
      subtitleColorId,
      tempoId,
      withShort,
    } = data

    if (!templateTitle) {
      setErrorText(
        '영상 제목(26자 제한) 입력을 하셔야 영상 생성 요청이 가능합니다.'
      )
      setEssentialCheck(true)
      return
    }

    if (isDisabled) {
      setErrorText('이미지를 1장 이상 선택해주세요!')
      setEssentialCheck(true)
      return
    }

    const selectedImageData = selectedOrder.map((value, _) => images[value])
    const selectedUploadImageData = uploadImages.map((el) => el.preview)
    const urls = [
      ...(selectedUploadImageData ?? []),
      ...(selectedImageData ?? []),
    ]

    const prevInfo = {
      mainTitle,
      link,
      voiceId,
      userVoiceId,
      bgmId,
      aiToneTypeId,
      backgroundId,
      templateId,
      subtitleId,
      templateType,
      aiPromptDurationId,
      subtitleColorId,
      tempoId,
    }
    saveLocalStorage('shortVideoData', prevInfo)
    mainTitle = mainTitle.trim()

    // 가격 정보 및 계산(배경영상, 배경음악, 목소리)
    const bgInfo = bgList?.filter((el) => el.id === backgroundId)
    const bgmInfo = bgmList?.filter((el) => el.id === bgmId)
    const subtitleInfo = subTitleList?.filter((el) => el.id === subtitleId)

    const voiceInfo = voiceList?.find((el) => el.id === voiceId)
    const userVoiceInfo = userVoiceList?.find((el) => el.id === userVoiceId)
    let voicePrice = 0
    if (voiceInfo) {
      voicePrice = voiceInfo.originPrice
    } else if (userVoiceInfo) {
      voicePrice = userVoiceInfo.originPrice
    }

    const temType: 'clip' | 'image' | 'mix' | 'placid' = templateType
    let templateInfo = templateList
      ? templateList[temType]?.list.filter((el) => el.id === templateId)
      : []

    setShortVideoPriceInfo({
      bgmPrice: bgmInfo ? Number(bgmInfo[0].originPrice) : 0,
      voicePrice: Number(voicePrice),
      templatePrice: templateInfo ? Number(templateInfo[0].originPrice) : 0,
      subtitlePrice: subtitleInfo ? Number(subtitleInfo[0].originPrice) : 0,
    })

    const shortVideoInfo = {
      mainTitle,
      templateTitle,
      link,
      voiceId,
      userVoiceId,
      bgmId,
      backgroundId: 1,
      templateId,
      templateType,
      subtitleId,
      subtitleColorId,
      aiToneTypeId,
      aiPromptDurationId,
      tempoId,
      urls,
      amount: 0,
      withShort,
    }
    if (Number(voiceId) === 0 && Number(userVoiceId) !== 0) {
      delete shortVideoInfo.voiceId
    } else if (Number(voiceId) !== 0 && Number(userVoiceId) === 0) {
      delete shortVideoInfo.userVoiceId
    }

    setShortVideoInfo(shortVideoInfo)
    setUseModal(true)
  }

  const [isOpen, setIsOpen] = useState(true)

  const toggleContent = () => {
    setIsOpen(!isOpen)
  }

  const [voicePlaying, setVoicePlaying] = useState<boolean[]>(
    new Array(voiceList?.length).fill(false)
  )

  const [tempoPlaying, setTempoPlaying] = useState<boolean[]>(
    new Array(tempoList?.length).fill(false)
  )

  const [bgmPlaying, setBgmPlaying] = useState<boolean[]>(
    new Array(bgmList?.length).fill(false)
  )

  const [toneTooltip, setToneTooltip] = useState<boolean[]>([])

  //여러개 tooltip 관리

  const btnRef = useRef<HTMLButtonElement>(null)

  const voiceRefs = useRef<(HTMLAudioElement | null)[]>([])
  const bgmRefs = useRef<(HTMLAudioElement | null)[]>([])

  const handleBgmPlayButtonClick = (status: boolean, index: number) => {
    const updatedPlayingState = bgmPlaying.map((value, idx) =>
      idx === index ? status : false
    )
    setBgmPlaying(updatedPlayingState)

    if (bgmRefs.current[index]) {
      if (status) {
        bgmRefs.current[index]?.play()
      } else {
        bgmRefs.current[index]?.pause()
      }
    }
  }

  const setVideoData = () => {
    if (!shortVideoData)
      return initializeDefaults({
        setValue,
        toneList,
        voiceList,
        templateList,
        bgList,
        bgmList,
        subTitleList,
        aiPromptDurationList,
        subtitleColorList,
        tempoList,
        setSelectedImagePath,
      })

    const {
      mainTitle,
      link,
      voiceId,
      userVoiceId,
      bgmId,
      aiToneTypeId,
      backgroundId,
      templateId,
      templateType,
      aiPromptDurationId,
      subtitleId,
      subtitleColorId,
      tempoId,
    } = shortVideoData

    if (memory === 'true') {
      setValue('mainTitle', mainTitle)
      setValue('link', link)
    }
    if (backgroundId) {
      setValue('backgroundId', 1)
    }

    if (subtitleId) {
      setValue('subtitleId', subtitleId)
    } else if (!subtitleId || Number(templateId) === 0) {
      if (subTitleList) {
        setValue('subtitleId', subTitleList[0].id)
      }
    }

    if (templateId) {
      const selectedTemplate = templateList?.placid.list.find(
        (el) => el.id === templateId
      )
      if (selectedTemplate) {
        setValue('templateId', selectedTemplate.id)
        setValue('templateType', selectedTemplate.type)
        setSelectedImagePath(selectedTemplate.path)
      } else {
        const defaultItem = templateList?.placid?.list.find(
          (el) => el.default === 1
        )

        if (defaultItem) {
          setValue('templateId', defaultItem.id)
          setValue('templateType', defaultItem.type)
          setSelectedImagePath(defaultItem.path)
        }
      }
    } else {
      const defaultItem = templateList?.placid?.list.find(
        (el) => el.default === 1
      )

      if (defaultItem) {
        setValue('templateId', defaultItem.id)
        setValue('templateType', defaultItem.type)
        setSelectedImagePath(defaultItem.path)
      }
    }

    if (aiToneTypeId) {
      if (toneList) {
        const [tone] = toneList?.filter((el) => el?.id === aiToneTypeId)
        if (tone) {
          setValue('aiToneTypeId', aiToneTypeId)
        } else {
          setValue('aiToneTypeId', toneList[0]?.id)
        }
      }
    } else if (toneList) {
      setValue('aiToneTypeId', toneList[0]?.id)
    }

    if (voiceId) {
      setValue('voiceId', voiceId)
    }
    if (userVoiceId) {
      setValue('userVoiceId', userVoiceId)
    }

    if (bgmId) {
      setValue('bgmId', bgmId)
    }
    if (aiPromptDurationId) {
      if (aiPromptDurationList) {
        setValue('aiPromptDurationId', aiPromptDurationList[1].id)
      }
    }
    if (subtitleColorId) {
      setValue('subtitleColorId', subtitleColorId)
    } else if (subtitleColorList) {
      setValue('subtitleColorId', subtitleColorList[0]?.id)
    }

    if (tempoId) {
      setValue('tempoId', tempoId)
    } else if (tempoList) {
      setValue('tempoId', tempoList[0]?.id)
    }
  }
  useEffect(() => {
    voiceRefs.current.forEach((audioRef, index) => {
      if (audioRef && !voicePlaying[index]) {
        audioRef.pause()
        audioRef.currentTime = 0
      }
    })
  }, [voicePlaying])

  useEffect(() => {
    bgmRefs.current.forEach((audioRef, index) => {
      if (audioRef && !bgmPlaying[index]) {
        audioRef.pause()
        audioRef.currentTime = 0
      }
    })
  }, [bgmPlaying])
  useEffect(() => {
    if (voiceList) {
      setVoicePlaying(new Array(voiceList?.length).fill(false))
    }
    if (bgmList) {
      setBgmPlaying(new Array(bgmList?.length).fill(false))
    }
    if (toneList) {
      setToneTooltip(new Array(toneList.length).fill(false))
    }
    if (tempoList) {
      setTempoPlaying(new Array(tempoList.length).fill(false))
    }
    setVideoData()
    if (amount && pType && bonus && pType === 'success') {
      setAmountValue(Number(amount) * (10 / 11))
      if (bonus) {
        setBonusValue(Number(bonus))
      }
      setModal(true)
    }
    if (mType === 'true') {
      if (btnRef.current) {
        btnRef.current.click()
        navigate(pathname)
      }
    }
  }, [
    location.search,
    userInfo,
    toneList,
    bgmList,
    voiceList,
    bgList,
    animationList,
    aiPromptDurationList,
    subTitleList,
  ])
  useEffect(() => {
    getMyPointRefetch()
  }, [])

  const handleBlur = async (url: string) => {
    if (url) {
      try {
        const result = await getShortImageList(url)

        const { title, images, titlesSplit } = result

        setValue('mainTitle', title)
        setValue('templateTitle', titlesSplit[0] ?? '')
        setImages(images)
        setSpiltTitles(titlesSplit)

        setSuccess(true)
      } catch (e: any) {
        // @ts-ignore
        const serverErrorMsg = e.response?.data?.message || ''
        if (serverErrorMsg === '410') {
          setErrorCode(Number(serverErrorMsg))
        }
        setErrorText(serverErrorMsg)
        setEssentialCheck(true)
        setHasLinkError(true)
        setSuccess(false)
      }
      setCrawlingLoading(false)
    }
  }

  const handleCrwaling = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setCrawlingLoading(true)
    await handleBlur(linkValue)
  }

  const handleRemoveLink = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setValue('link', '')
    setValue('templateTitle', '')
    setValue('mainTitle', '')
    setSpiltTitles([])
    setImages([])
    setSelectedOrder([])
    setSuccess(false)
    setHasLinkError(false)
    setCrawlingLoading(false)
  }

  const scrollToRef = useRef<HTMLDivElement>(null)
  const handleScroll = () => {
    if (scrollToRef.current) {
      // scrollIntoView를 사용해 해당 위치로 스크롤
      scrollToRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <>
      {' '}
      <div className="flex flex-col relative mt-5 ">
        <div className="w-full absolute h-[102px] z-40 flex ">
          <button
            className={classNames(
              'w-[50%] h-full md:rounded-tl-[40px] flex items-start justify-center ',
              {
                ' bg-[#2E343D]  text-white': tab === 'link',
                ' bg-[#EEF1F7]   text-[#8F929B]': tab !== 'link',
              }
            )}
            onClick={() => {
              changeTab('link')
            }}
          >
            <span className="  text-[18px] font-bold pt-5">링크로 만들기</span>
          </button>
          <button
            className={classNames(
              'w-[50%] h-full md:rounded-tr-[40px] flex items-start justify-center ',
              {
                ' bg-[#2E343D]  text-white': tab === 'text',
                ' bg-[#EEF1F7]   text-[#8F929B]': tab !== 'text',
              }
            )}
            onClick={() => {
              changeTab('text')
            }}
          >
            <span className=" text-[18px] font-bold pt-5">텍스트로 만들기</span>
          </button>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit, (err) => {
            userCheck()
            const { templateTitle, mainTitle, link } = err
            console.log(err)

            const selectErrorText = (mainTitle: any, link: any) => {
              let mainTitleErrorText =
                '유튜브용 제목(50자 제한) 입력을 하셔야 영상 생성 요청이 가능합니다.'
              let linkErrorText = '뉴스 링크'
              let errorStr = ''
              if (mainTitle && link) {
                errorStr = `${linkErrorText}, ${mainTitleErrorText}`

                if (mainTitleInputRef.current) {
                  mainTitleInputRef.current.focus()
                  mainTitleInputRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  })
                }
              } else if (link) {
                errorStr = `${linkErrorText} 입력을 하셔야 영상 생성 요청이 가능합니다.`

                if (mainTitleInputRef.current) {
                  mainTitleInputRef.current.focus()
                  mainTitleInputRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  })
                }
              } else if (templateTitle) {
                errorStr = ` ${mainTitleErrorText}`

                if (mainTitleInputRef.current) {
                  mainTitleInputRef.current.focus()
                  mainTitleInputRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  })
                }
              }

              setErrorText(errorStr)
            }
            selectErrorText(mainTitle, link)
            setEssentialCheck(true)
          })}
          className={`flex flex-col gap-[20px] mt-[60px] z-40`}
        >
          <ShadowBox className="py-[40px]  md:w-[816px] bg-[#FFFFFF]">
            <div
              className="flex flex-col gap-[16px]  w-full "
              ref={scrollToRef}
            >
              <div className="flex flex-col gap-[16px]">
                <div className="flex flex-col w-full md:w-full ml-4 md:ml-0">
                  <div className="relative w-[210px]">
                    <h3 className="font-bold text-[#2E343D] text-[20px] md:text-[24px] ">
                      컨텐츠 링크 입력
                    </h3>
                    <ContentTooltip
                      setContentTooltipStatus={setContentTooltipStatus}
                      contentTooltipStatus={contentTooltipStatus}
                    />
                  </div>
                  <p className="text-main text-[14px]">
                    <span className="font-bold">
                      네이버 블로그, 티스토리, 워드프레스, 네이버 뉴스/연예/스포
                      {isMobile && <br />}츠
                    </span>
                    만 동작하며, 저작권에 유의해주세요!
                  </p>
                </div>
                <div className="flex flex-col items-center w-full md:w-[736px]  gap-[8px]">
                  <div className="relative">
                    <Controller
                      name={'link'}
                      rules={{
                        required: {
                          value: true,
                          message: 'URL 입력은 필수입니다!',
                        },
                      }}
                      render={({
                        field: { onChange, onBlur, value, ...field },
                      }) => (
                        <>
                          {isMobile ? (
                            <TextArea
                              userCheck={userCheck}
                              inputRef={mainTitleInputRef}
                              value={value}
                              error={value.length > 0 && hasLinkError}
                              {...field}
                              onChange={onChange}
                              placeholder="컨텐츠 링크 붙여넣기"
                              disabled={isSuccess}
                            />
                          ) : (
                            <Input
                              userCheck={userCheck}
                              inputRef={mainTitleInputRef}
                              value={value}
                              error={value.length > 0 && hasLinkError}
                              {...field}
                              placeholder="컨텐츠 링크 붙여넣기"
                              disabled={isSuccess}
                              onChange={onChange}
                            />
                          )}
                        </>
                      )}
                      control={control}
                    />
                    <div className="flex gap-[16px] absolute right-4 bottom-5  md:right-4 md:bottom-0 md:top-0 items-center ">
                      <button
                        onClick={handleRemoveLink}
                        disabled={watch(`link`) === '' || isCrawlingLoading}
                      >
                        <img
                          className="w-[24px] h-[24px]  md:w-[32px] md:h-[32px]"
                          src="assets/img/icon_circle_x.png"
                          alt="x"
                        />
                      </button>
                      <button
                        className={classNames(
                          'bg-[#6B8ACB] hover:bg-[#8FABE5] text-white px-[20px] py-[10px]  md:px-[24px] md:py-[16px] md:w-[76px] md:h-[51px]   flex items-center justify-center rounded-[10px] font-bold disabled:opacity-[0.3]',
                          {
                            ' active:scale-95': !isSuccess,
                          }
                        )}
                        onClick={handleCrwaling}
                        disabled={
                          watch(`link`) === '' || isCrawlingLoading || isSuccess
                        }
                      >
                        {isCrawlingLoading ? (
                          <span className="loader"></span> // 로더 컴포넌트
                        ) : (
                          '적용' // 적용 버튼 텍스트
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <ImageUploadBox
                isSuccess={isSuccess}
                images={images}
                selectedImages={selectedImages}
                setSelectedImages={setSelectedImages}
                selectedUploadImages={selectedUploadImages}
                setSelectedUploadImages={setSelectedUploadImages}
                uploadImages={uploadImages}
                setUploadImages={setUploadImages}
                selectedOrder={selectedOrder}
                setSelectedOrder={setSelectedOrder}
              />

              <div className="flex flex-col gap-[16px]">
                <div className=" flex flex-col ml-4 md:ml-0">
                  <div className="relative flex items-center gap-2">
                    {' '}
                    <h3 className="font-bold text-[#2E343D] md:text-[24px] text-[20px] ">
                      유튜브용 제목 입력
                    </h3>
                    {/* <ShortVideoTitleTooltip
                      setTitleTooltip={setTitleTooltip}
                      titleTooltip={titleTooltip}
                    /> */}
                  </div>

                  <p className="text-main text-[14px]">
                    유튜브에 업로드 할 때 사용할 제목입니다.
                  </p>
                </div>
                <div className="flex flex-col items-center w-full md:w-[736px] gap-[8px]">
                  <div className="relative">
                    <Controller
                      render={({ field }) => (
                        <>
                          {isMobile ? (
                            <TextArea
                              userCheck={userCheck}
                              inputRef={mainTitleInputRef}
                              error={
                                field.value.length > 50 ||
                                !PRODUCT_NAME_PATTERN.test(field.value)
                                  ? true
                                  : false
                              }
                              {...field}
                              placeholder="컨텐츠 영상 제목을 입력해주세요"
                              maxLength={50}
                            />
                          ) : (
                            <Input
                              userCheck={userCheck}
                              inputRef={mainTitleInputRef}
                              error={
                                field.value.length > 50 ||
                                !PRODUCT_NAME_PATTERN.test(field.value)
                                  ? true
                                  : false
                              }
                              {...field}
                              placeholder="유튜브용 제목을 입력해주세요"
                              maxLength={50}
                            />
                          )}
                          <div
                            className={`flex gap-[4px] mt-[8px] ${
                              (field.value.length > 50 ||
                                !PRODUCT_NAME_PATTERN.test(field.value)) &&
                              'text-error'
                            }`}
                          >
                            <span className="md:text-base text-[14px]">
                              {field.value.length}/50
                            </span>
                            <span className="md:text-base text-[14px]">{`이모지, 한자(漢字), 꺽쇠괄호(< >) 는 허용되지 않습니다.`}</span>
                          </div>
                        </>
                      )}
                      name={'mainTitle'}
                      rules={{
                        required: {
                          value: true,
                          message: '컨텐츠 영상 제목은 필수입니다!',
                        },
                        maxLength: {
                          value: 90,
                          message: '유튜브 영상 제목의 길이가 50자를 넘습니다.',
                        },
                        validate:
                          watch(`mainTitle`) !== ''
                            ? (value) => {
                                return (
                                  PRODUCT_NAME_PATTERN.test(value) ||
                                  '이모지와 꺽쇠괄호(< >)는 허용되지 않습니다.'
                                )
                              }
                            : undefined,
                      }}
                      control={control}
                    />
                  </div>
                </div>
              </div>

              <VideoRatioType />
            </div>
          </ShadowBox>
          {!isSuccess && (
            <FeatureDescription
              description1="컨텐츠 링크"
              description2="영상 관련 기능"
            />
          )}
          <ShadowBox
            className={classNames('py-[40px] px-[16px] md:w-[816px]', {
              'opacity-30 pointer-events-none': !isSuccess,
            })}
          >
            <div className="flex flex-col gap-[40px] md:gap-0 w-[343px] md:w-[736px]">
              <div className="flex flex-col items-center  mt-[16px] md:mb-[40px] relative ">
                <p className="font-bold text-[#2E343D] text-[24px] ">
                  효과 선택
                </p>
                <p className="text-main text-[14px]">
                  원하는 분위기의 영상 생성을 위해 각 효과를 선택해주세요!
                </p>
                {/* <div className="md:absolute  md:right-0 md:mt-0 mt-4 flex flex-col items-center">
                  <p className=" bg-clip-text text-transparent bg-gradient-to-r from-[rgba(96,149,255,1)] to-[rgba(213,18,231,1)]">
                    지금 놓치면 끝!
                  </p>
                  <p className="text-[#FD6767]">🔥 6/30 까지만</p>
                  <img
                    src="assets/img/short_video_editor/sale.png"
                    alt="sale"
                    width={141}
                    height={32}
                  />
                </div> */}
              </div>
              <CSSTransition
                in={isOpen}
                timeout={200}
                classNames="content"
                unmountOnExit
              >
                <div className="">
                  <ContentLayoutSelector
                    watch={watch}
                    control={control}
                    setValue={setValue}
                    userInfo={userInfo}
                    templateList={templateList}
                    splitTitles={splitTitles}
                    selectedImagePath={selectedImagePath}
                    setSelectedImagePath={setSelectedImagePath}
                  />
                  <AiScriptDisplay
                    watch={watch}
                    setValue={setValue}
                    control={control}
                    userInfo={userInfo}
                    toneList={toneList}
                    tempoList={tempoList}
                    setPromptStatus={setPromptStatus}
                    promptStatus={promptStatus}
                    voiceList={voiceList}
                    setVoicePlaying={setVoicePlaying}
                    setTempoPlaying={setTempoPlaying}
                    tempoPlaying={tempoPlaying}
                    voicePlaying={voicePlaying}
                    voiceTags={voiceTags}
                    setToneTooltip={setToneTooltip}
                    toneTooltip={toneTooltip}
                    userVoiceList={userVoiceList}
                    userVoiceRefetch={userVoiceRefetch}
                  />
                  <SubtitleDisplay
                    subTitleList={subTitleList ?? []}
                    watch={watch}
                    control={control}
                    setValue={setValue}
                    userInfo={userInfo}
                    setSubtitleTooltip={setSubtitleTooltip}
                    subtitleTooltip={subtitleTooltip}
                    subtitleColorList={subtitleColorList ?? []}
                  />

                  <ShortBgmDisplay
                    bgmList={bgmList ?? []}
                    setBgmPlaying={setBgmPlaying}
                    bgmPlaying={bgmPlaying}
                    watch={watch}
                    setValue={setValue}
                    bgmRefs={bgmRefs}
                    handleBgmPlayButtonClick={handleBgmPlayButtonClick}
                    userInfo={userInfo}
                    control={control}
                    bgmTooltip={bgmTooltip}
                    setBgmTooltip={setBgmTooltip}
                  />
                </div>
              </CSSTransition>
              <div className="flex items-center justify-center">
                <button
                  className="flex items-center justify-center gap-[8px] w-full py-[12.5px] bg-[#EEF1F7] rounded-[40px]"
                  type="button"
                  onClick={toggleContent}
                >
                  <span>{isOpen ? '접기' : '펼치기'}</span>
                  <img
                    src="assets/img/icon_up_arrow.png"
                    alt="arrow"
                    className={`w-[12.8px] h-[8.25px]  transition-transform duration-500 ${
                      isOpen ? '' : 'rotate-180'
                    }`}
                  />
                </button>
              </div>
            </div>
          </ShadowBox>
          <div
            className="text-[16px] text-center"
            style={{
              opacity: isDisabled ? 0.3 : 1,
              pointerEvents: isDisabled ? 'none' : 'auto',
            }}
          >
            패스트컷은 사용자가 제공하는 URL에 있는 텍스트/이미지/영상을 토대로
            영상을 만들고 있으며,
            <br /> 링크 내의 텍스트나 이미지, 영상 등이 영상에 사용될 수
            있습니다.
            <br /> 이에 대한 지적재산권 침해 여부는 사용자가 확인하여야 하며,
            이에 관하여 패스트컷은 책임이 없습니다.
          </div>
          <div>
            <div
              className="flex flex-col justify-center items-center gap-[20px]"
              style={{
                opacity: !isSuccess ? 0.3 : 1,
              }}
            >
              <button
                type="submit"
                className={classNames(
                  'h-[60px] flex items-center justify-center bg-main gap-[4px] w-[343px] md:w-full border-none rounded-[30px] hover:bg-hover text-[#FFFFFF] font-bold'
                )}
                ref={btnRef}
                disabled={!isSuccess}
              >
                <span>컨텐츠 영상 생성 요청</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      {essentialCheck && (
        <Modal isModal={essentialCheck}>
          <div className="bg-white w-[335px] h-[184px] p-[20px] border-t rounded-t-[20px]">
            <div className="flex flex-col items-center justify-center h-full gap-[24px]">
              <p className="font-bold text-[18px]">
                🙌 필수 정보를 확인해주세요!
              </p>
              {errorCode === 410 ? (
                <>
                  {' '}
                  <p className="text-[14px]">
                    쿠팡/알리 링크를 사용할 수 없습니다 <br />
                    상품 컨텐츠 영상은 상품 영상 만들기 화면에서 상품 영상과
                    함께 생성해주세요!
                  </p>{' '}
                </>
              ) : (
                <p className="text-[14px]">{errorText}</p>
              )}

              {/* <p className="text-red-500">{errorMessage}</p> */}
            </div>
          </div>
          <div className="w-[335px]  h-[60px] rounded-b-[20px] flex justify-center items-center font-bold">
            {errorCode === 410 ? (
              <>
                <button
                  className="text-[#5E6068] w-[50%] h-full bg-[#EEF1F7] border-b  border-[#EEF1F7] rounded-bl-[20px]"
                  onClick={() => {
                    setEssentialCheck(false)
                  }}
                >
                  닫기
                </button>{' '}
                <button
                  className="text-white w-[50%]  h-full bg-main  border-b  border-main rounded-br-[20px]"
                  onClick={() => {
                    setEssentialCheck(false)
                    navigate('/video-editor')
                  }}
                >
                  상품영상 만들러 가기
                </button>
              </>
            ) : (
              <>
                <button
                  className="text-white w-[335px] rounded-b-[20px] h-full bg-main  border-b  border-main"
                  onClick={() => {
                    setEssentialCheck(false)
                  }}
                >
                  확인
                </button>
              </>
            )}
          </div>
        </Modal>
      )}
      {saveSuccessModal && (
        <Modal isModal={saveSuccessModal}>
          <div className="bg-white w-[335px] h-[184px] p-[20px] border-t rounded-t-[20px]">
            <div className="flex flex-col items-center justify-center h-full gap-[24px]">
              <p className="font-bold text-[18px]">요청 완료</p>
              <div>
                <p className="text-[14px] font-bold">
                  컨텐츠 영상 생성이 요청 되었습니다!
                </p>
                <p className="text-[14px] font-bold">
                  생성 현황은 <span className="text-main">‘사용 현황‘</span>{' '}
                  페이지에서 확인하세요.
                </p>
              </div>
            </div>
          </div>
          <div className="flex  w-[335px]">
            <div className="w-[50%] bg-[#EEF1F7] h-[60px] border-b border-[#EEF1F7] rounded-bl-[20px] flex justify-center items-center">
              <button
                className="text-[#5E6068] w-full font-bold"
                onClick={() => {
                  navigate('/my-videos?type=lcv&page=1&pageSize=80')
                }}
              >
                사용현황 페이지 가기
              </button>
            </div>
            <div className="w-[50%] bg-main h-[60px] border-b border-main rounded-br-[20px] flex justify-center items-center">
              <button
                className="text-white w-full font-bold"
                onClick={(event) => {
                  setSaveSuccessModal(false)
                  handleRemoveLink(event)
                  handleScroll()
                }}
              >
                확인
              </button>
            </div>
          </div>
        </Modal>
      )}
      {isModal && (
        <ConfirmPaymentCashModal
          isModal={isModal}
          setModal={setModal}
          amount={amountValue}
          bonusValue={bonusValue}
          valid={valid ? valid : ''}
          promotionCode={promotionCode ? Number(promotionCode) : 0}
        />
      )}
      {/* 캐시 사용 모달*/}
      {isUseModal && (
        <CashUseModal
          isUseModal={isUseModal}
          setUseModal={setUseModal}
          currentPoint={myPointData.totalPoint}
          shortVideoInfo={shortVideoInfo}
          shortVideoPriceInfo={shortVideoPriceInfo}
          setSaveSuccessModal={setSaveSuccessModal}
          setValue={setValue}
          getMyPointRefetch={getMyPointRefetch}
          setRequest={setRequest}
        />
      )}
      {isPending && (
        <>
          {' '}
          <Spinner />
        </>
      )}
    </>
  )
}
